<template>
  <StudioMultiSelect
    v-model="pagesSelected"
    :searchable="true"
    :items="pagesItems"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ selected.length }} {{ message }}
      </span>
    </template>

    <template v-slot:item="{item}">
      <ChannelSelectItem
        :item="item"
      />
    </template>
  </StudioMultiSelect>
</template>

<script>
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import ChannelSelectItem from '@/components/filter/ChannelSelectItem';
import EventBus from '@/utils/event-bus';
import pagesModel from '@/mixins/pages-model';
import { isEqual } from 'lodash';

export default {
  name: 'PageFilter',
  components: {
    StudioMultiSelect,
    ChannelSelectItem,
  },
  mixins: [
    pagesModel,
  ],
  props: {
    value: {
      type: [Object, Array],
      default: () => ({}),
    },
    pagesItems: {
      type: Array,
      default: () => ([]),
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      label: 'Páginas',
      placeholder: 'Todas',
      selected: [],
    };
  },
  computed: {
    pagesSelected: {
      get() {
        if (this.value && this.value.value) {
          return this.value.value;
        }

        return [];
      },
      set(newValue) {
        let newPages = newValue;
        if (!newPages || newPages.length === 0) {
          this.selected = [];
        }

        if (typeof (newPages[0]) === 'object') {
          newPages = newPages.map(v => v && v.value);
        }

        this.selected = [...newPages];
        this.$emit('input', {
          value: this.selected,
        });
      },
    },
    selectedChannels() {
      return this.pagesSelected.map(pageId => {
        return this.pages.find(page => page.value === pageId).channel;
      });
    },
    message() {
      return this.selected.length === 1 ? 'selecionado' : 'selecionados';
    },
  },
  watch: {
    selected: {
      handler (newPages, oldPages) {
        if (!isEqual(oldPages, newPages)) {
          EventBus.$emit('changedPages');
        }
      },
      deep: true,
    },
  },
  created() {
    this.selected = [...this.pagesSelected];

    EventBus.$on('clearTikTokPages', () => {
      if (!Boolean(this.tikTokPages.length)) return;
      EventBus.$emit('showTikTokAlert');
      this.pagesSelected = this.selected.filter(page => !this.tikTokPages.includes(page));
    });
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
